import { store } from '../store';

const iamSdk = window.__USERCENTER__;

export async function initIam() {
  return new Promise(async (resolve, reject) => {
    try {
      iamSdk.configUserCenter({
        clientId: process.env.REACT_APP_IAM_CLIENT_ID || '',
        ssoUrl: process.env.REACT_APP_IAM_SSO_URL || '',
        tokenUrl: process.env.REACT_APP_IAM_TOKEN_URL || '',
        extra: {
          debugLog: true,
        },
      });
      const res = await iamSdk.login();
      console.log('res=====', res);
      if (res.success) {
  
        // 登录成功后，获取最新的token和userInfo
        store.setAuth(res.token, res.userInfo);
        console.log('用户认证信息已更新到store');
        
        resolve(res);
      } else {
        // 登录失败时清除store中的认证信息
        store.clearAuth();
        reject(false);
      }
    } catch (error) {
      console.log('error=====', error);
      // 发生错误时清除store中的认证信息
      store.clearAuth();
      reject(false);
    }
  });
}
